
export const mapTaskRiskControls = (data: any) => ({
  ...data,
  title: data.control?.control_id,
});
